const $$splitComponentImporter = () => import('/app/src/routes/dashboard/admin/videos/$videoId.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/dashboard/admin/videos/$videoId")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});